<template>
	<modal ref="modal" size="shadow border">
		<template #title>Member - Update Special Discount</template>
		<template #body>
			<div class="mb-4">
				<label class="form-label" for="amount">Membership Level</label>
				<select v-model="formUpdate.membership_level" class="form-select">
					<option value="ALL">ALL</option>
					<option value="SILVER">SILVER</option>
					<option value="GOLD">GOLD</option>
					<option value="DIAMOND">DIAMOND</option>
					<option value="PLATINUM">PLATINUM</option>
					<option value="PLATINUM COUPLE">PLATINUM COUPLE</option>
				</select>
			</div>
			<div class="mb-4">
				<label class="form-label" for="amount">Applicable for Mininum Month</label>
				<select v-model="formUpdate.min_month" class="form-select">
					<option value="3">3 Months</option>
					<option value="6">6 Months</option>
					<option value="12">12 Months</option>
				</select>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="formUpdate.discount_type"
					id="discount_type"
					class="form-select"
					placeholder="Select Discount Type"
					:class="{ 'is-invalid': formUpdate.errors.discount_type }"
				>
					<option value="amount">Amount</option>
					<option value="percentage">Percentage</option>
				</select>
				<label class="form-label" for="amount">Discount Type</label>
			</div>
			<div class="form-floating mb-4">
				<input v-model="formUpdate.amount" type="number" name="amount" class="form-control" placeholder="Amount" min="0" />
				<label class="form-label" for="amount">Amount</label>
			</div>
			<div class="form-floating mb-4">
				<select
					v-model="formUpdate.is_active"
					id="is_active"
					class="form-select"
					:class="{ 'is-invalid': formUpdate.errors.is_active }"
				>
					<option value="1">Yes</option>
					<option value="0">No</option>
				</select>
				<label class="form-label" for="amount">Active</label>
			</div>
		</template>
		<template #footer>
			<button
				@click="updateSpecialDiscount"
				type="button"
				class="btn btn-alt-primary"
				:disabled="formUpdate.processing || formUpdate.amount==0"
			>
				<div
					v-if="formUpdate.processing"
					class="spinner-border spinner-border-sm text-dark me-1"
					role="status"
				>
					<span class="sr-only">Processing...</span>
				</div>
				<i v-else class="fa fa-save me-1"></i>
				<span>
					Update
				</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="formUpdate.processing"
			>
				Close
			</button>
		</template>
	</modal>

</template>

<script>
import { ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const formUpdate = useForm({
			expired_discount_id	: 0,
			is_active			: 1,
			membership_level	: '',
			min_month			: 3,
			discount_type		: 'amount',
			amount 				: 0,
		})

		const setContent = (data)=>{
			formUpdate.expired_discount_id 		= data.expired_discount_id;
			formUpdate.membership_level			= data.membership_level;
			formUpdate.min_month 				= data.min_month;
			formUpdate.discount_type 			= data.discount_type;
			formUpdate.amount 					= data.amount;
			formUpdate.is_active 				= data.is_active;
		}

		const updateSpecialDiscount = () => {
			formUpdate.put(route('admin.user-management.put.expired-member-special-discount',{expired_discount_id:formUpdate.expired_discount_id}), {
				preserveState: true,
				preserveScroll: true,
				onSuccess: () => {
					formUpdate.reset()
					toggleModal()
				},
			})
		}

		return {
			formUpdate,
			modal,
			toggleModal,
			setContent,
			updateSpecialDiscount,
		}
	},
}
</script>
